/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const AbsenceDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 34"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none">
      <g transform="translate(17.333333, 17.333333)">
        <circle id="Oval" cx="7.33333333" cy="7.33333333" r="6.66666667" />
        <path d="M4.33333333,4.33333333 L10.3333333,10.3333333" strokeLinecap="round" />
        <path d="M10.3333333,4.33333333 L4.33333333,10.3333333" strokeLinecap="round" />
      </g>
      <path d="M16.6666667,19.3333333 L16.6666667,15.5946667" strokeLinecap="round" />
      <path
        d="M10,15.5946667 L10,19.3333333 L3.32133333,21.7186667 C1.72933333,22.288 0.666666667,23.796 0.666666667,25.4853333 L0.666666667,28.6666667 L15.3333333,28.6666667"
        id="Shape"
        strokeLinecap="round"
      />
      <ellipse cx="13.3333333" cy="8.66666667" rx="6.66666667" ry="8" />
      <path d="M19.9373333,7.93733333 C19.7133333,7.96533333 19.5586667,7.956 19.3333333,8 C17.0626667,8.43733333 15.604,7.61466667 14.3546667,5.42666667 C13.604,6.864 11.2586667,8 9.33333333,8 C8.38533333,8 7.56933333,7.80533333 6.752,7.37866667" />
    </g>
  </svg>
);

export default AbsenceDetailsIcon;
